import { create } from "zustand";

export const useMotivosStore = create((set)=>({
    motivos : null,

    setMotivos:(motivos)=>{
        set({motivos:motivos})
    }
}))
